import styled from "@emotion/styled";
import { map } from "lodash-es";

import { MDSText, MDSTextColor, MDSTextVariant } from "@/mds";
import { AgentSectionHeader } from "@/pages/agent/components/agent-section-header";
import { AgentProjectCard } from "@/pages/agent/projects/agent-project-card";
import {
  ProjectSectionKind,
  type ProjectCardViewModel,
} from "@/pages/agent/projects/agent-projects-page.utils";

export const AgentProjectsSection = ({
  title,
  kind,
  projectCards,
  onOpenActivities,
  onOpenProject,
  onOpenTasks,
  onOpenNextUp,
  onCommentProject,
}: {
  title: string;
  kind: ProjectSectionKind;
  projectCards: ProjectCardViewModel[];
  onOpenActivities: () => void;
  onOpenProject: ({ projectId }: { projectId: string }) => void;
  onOpenTasks: () => void;
  onOpenNextUp: ({ projectId }: { projectId: string }) => void;
  onCommentProject: ({ projectId }: { projectId: string }) => void;
}) => (
  <StyledSectionRoot>
    <AgentSectionHeader title={title} />

    {projectCards.length === 0 ? (
      <StyledEmptyState>
        <MDSText color={MDSTextColor.Secondary} variant={MDSTextVariant.TextS}>
          {getStyledEmptyStateLabel({ kind })}
        </MDSText>
      </StyledEmptyState>
    ) : (
      <StyledProjectGrid>
        {map(projectCards, projectCard => (
          <AgentProjectCard
            key={projectCard.project.id}
            kind={kind}
            projectCard={projectCard}
            onOpenActivities={onOpenActivities}
            onOpenProject={onOpenProject}
            onOpenTasks={onOpenTasks}
            onOpenNextUp={onOpenNextUp}
            onCommentProject={onCommentProject}
          />
        ))}
      </StyledProjectGrid>
    )}
  </StyledSectionRoot>
);

const getStyledEmptyStateLabel = ({ kind }: { kind: ProjectSectionKind }) => {
  if (kind === ProjectSectionKind.Active) {
    return "No active projects";
  }

  return "No completed projects";
};

const StyledSectionRoot = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[3]};
`;

const StyledProjectGrid = styled.div`
  display: grid;
  gap: ${({ theme }) => theme.spacing[5]};
  grid-template-columns: repeat(2, minmax(0, 1fr));

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

const StyledEmptyState = styled.div`
  background: ${({ theme }) => theme.colors.background.input.chrome.default};
  border: 1px solid ${({ theme }) => theme.colors.border.surface};
  border-radius: 12px;
  padding: ${({ theme }) => theme.spacing[6]} ${({ theme }) => theme.spacing[5]};
`;
